import { useEffect } from 'react';

function collectSymbols(list) {
    return [...new Set((list || []).map((item) => item.symbol).filter(Boolean))];
}

export default function useStockQuotes(list, user_id, token, loadStockQuotes) {
    const symbolsKey = collectSymbols(list).sort().join(',');

    useEffect(() => {
        if (!symbolsKey || !user_id) return undefined;

        const symbols = symbolsKey.split(',').filter(Boolean);
        loadStockQuotes(symbols, user_id, token);

        const interval = setInterval(() => {
            loadStockQuotes(symbols, user_id, token);
        }, 60000);

        return () => clearInterval(interval);
    }, [symbolsKey, user_id, token, loadStockQuotes]);
}
